import axios from "axios";
import moment from "moment";
axios.defaults.baseURL = "https://exrx.us";
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    return Promise.reject(error);
  }
);
export const getToken = async () => {
  const exp = localStorage.getItem("exp");
  const token = localStorage.getItem("token");
  const tokenExp = parseInt(exp);
  if (
    !exp ||
    !token ||
    moment(tokenExp * 1000)
      .utc()
      .isBefore(moment().utc())
  ) {
    return await axios
      .post("/consumer/login", { username: "joseexrx", password: "ei99kmytd" })
      .then((response) => {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.token}`;
        const jwtObject = JSON.parse(atob(response.data.token.split(".")[1]));
        const { exp } = jwtObject;
        localStorage.setItem("exp", exp);
        localStorage.setItem("token", response.data.token);
      });
  }
  return Promise.resolve();
};
export const getExercises = async (query) => {
  return await axios.get(`exrxapi/v1/allinclusive/exercises?${query}&lang=es`);
};
